/** True when persona row is org AI-generated (not platform catalog). */
export function isAiGeneratedPersona(source?: string | null): boolean {
  return source === 'ai_generated';
}

/** True when persona row was generated from CRM data. */
export function isCrmPersona(source?: string | null): boolean {
  return source === 'crm_deal' || source === 'crm_aggregate';
}

/** True when persona was generated from a specific CRM deal. */
export function isCrmDealPersona(source?: string | null): boolean {
  return source === 'crm_deal';
}

/** True when persona was generated from aggregate CRM data. */
export function isCrmAggregatePersona(source?: string | null): boolean {
  return source === 'crm_aggregate';
}
